import React from "react";
import Button from "../../../../../server/public/shared/ui/inputs/classicButton.js";
import "./style.css";
export default function DeleteButton(props) {
    if ((props === null || props === void 0 ? void 0 : props.variant) === "cross") {
        return (React.createElement("button", { value: "delete button", onClick: props.onClick, className: "cross-delete-button" }, "\u00D7"));
    }
    return (React.createElement(Button, { value: "delete_btn", onClick: props.onClick, version: "transparent-stylish" },
        React.createElement("img", { 
            // eslint-disable-next-line react/no-unknown-property
            about: "https://uxwing.com/ - super website", src: "../assets/icons/delete.svg", width: "14" })));
}
